/* global globalThis */
import React, { useEffect } from 'react';

import CommonLoader from '../Views/Common/CommonLoader';
import { buildAuthPortalUrl } from 'utils/auth-portal-url';

const AuthPortalRedirect = ({ to, returnTo }) => {
  useEffect(() => {
    globalThis.location.replace(buildAuthPortalUrl(to, { returnTo }));
  }, [to, returnTo]);

  return <CommonLoader />;
};

export default AuthPortalRedirect;
